import React, { Component } from 'react'
import { NavLink } from 'react-router-dom';


export default class ErrorPage extends Component {
  render() {
    return (
      <form className="form" method action="#">
        <div className="header header-primary text-center">
          <h4>Error <strong>404</strong></h4>
        </div>
        <div className="content">
          <div className="row">
            <div className="col-md-12 text-center">
              <h4 className="mb-0 mt-40">Page not found</h4>
              <p className="text-muted">The requested page was not found</p>
            </div>
          </div>
          <div className="form-group mt-10">
            <input type="text" placeholder="Search..." className="form-control underline-input" />
          </div>
          <div className="footer text-center mb-20"> <NavLink to="/home" className="btn btn-info btn-raised"><i className="fa fa-home mr-10" />Return to home</NavLink> </div>
        </div>
      </form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Error/ErrorPage.js